import React, { createContext, ReactNode, useContext } from "react";

import { IDevelopmentProjectService } from "../types/services/development-project-service";

const DevelopmentProjectServiceContext = createContext<
  IDevelopmentProjectService
>(undefined as any);

interface DevelopmentProjectServiceProviderProps {
  children: ReactNode;
  service: IDevelopmentProjectService;
}

function DevelopmentProjectServiceProvider(
  props: DevelopmentProjectServiceProviderProps,
) {
  const { children, service } = props;

  return (
    <DevelopmentProjectServiceContext.Provider value={service}>
      {children}
    </DevelopmentProjectServiceContext.Provider>
  );
}

function useDevelopmentProjectService() {
  return useContext(DevelopmentProjectServiceContext);
}

export { DevelopmentProjectServiceProvider, useDevelopmentProjectService };
